angular.module("infoCliente.components", [])
    .component("infoCliente", {
        templateUrl: 'ng/components/monitorPratica/infoCliente/infoCliente.view.html',
        bindings: {
            client: '<'
        },
        controllerAs: 'infoCliCtrl',
        controller: InfoClientecontroller

    })

function InfoClientecontroller($userService) {
    var self = this;

    self.$onInit = function () {
        callRestInfoCliente();
    }

    var callRestInfoCliente = function () {
        self.loading = true;

        $userService.clientArcInfo(self.client.metadata.riUserG.cf)
            .then(function (response) {
                self.userInfo = response
                self.loading = false;
            })
            .catch(function (error) {
                console.log(error);
            })
    };
}